import { bl_cpcommerce_form_question_hdr_RowClass } from '../../dbschema/bl_cpcommerce_form_question_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class CpCommerceFormQuestionHdrContainerModel extends BaseContainerModel {
  bl_cpcommerce_form_question_hdr: bl_cpcommerce_form_question_hdr_RowClass = new bl_cpcommerce_form_question_hdr_RowClass();
}
